<template>
  <div style="background: transparent; padding: 0px">
    <DxPieChart
      id="pie"
      :data-source="props.widgetData.widgetThumbNailData"
      type="doughnut"
      palette="Dark Violet"
      :diameter="0.8"
      :inner-radius="0.7"
      :customize-point="customizePoint"
      center-template="centerTemplate"
    >
      <DxSeries argument-field="status" value-field="total" color="#83facf">
        <!-- <DxSmallValuesGrouping :top-count="10" mode="topN" /> -->
        <!-- <DxLabel :visible="true" :customize-text="customizeLabel" format="fixedPoint"  background-color="none" >
          <DxConnector :visible="true" :width="3" />
        </DxLabel> -->
        <!-- <DxLabel
        :visible="false"
        :customize-text="formatLabel"
        position="rows"
      >
        <DxConnector
          :visible="false"
          :width="2.5"
        /> -->
        <!-- <DxFont :size="18"/> -->
        <!-- </DxLabel> -->
        <!-- <DxHoverStyle color="#ffd700" />
        <DxSelectionStyle color="#17e850" border="true" border-color="blue" /> -->
      </DxSeries>

      <DxExport :enabled="false" />
      <DxLegend :visible="false" />

      <!-- <DxSize :height="130" :width="160" /> -->
      <!-- <DxSize :height="120" :width="150" /> -->
      <!-- <DxSize :height="110" :width="140" /> -->
      <DxSize :height="135" :width="135" />
      <!-- <DxAdaptiveLayout :height="100" :width="200" /> -->

      <template #centerTemplate="data">
        <CenterTemplateTwo :pie-chart="data.data" />
      </template>
    </DxPieChart>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import { useStoreWorkList } from "@/stores/workListsStore";
import DxPieChart, {
  DxLegend,
  DxSeries,
  DxExport,
  DxHoverStyle,
  DxSelectionStyle,
  DxSmallValuesGrouping,
  DxTooltip,
  DxFormat,
  DxLabel,
  DxConnector,
  DxAnnotation,
  DxCommonSeriesSettings,
  DxSize,
  DxAdaptiveLayout,
} from "devextreme-vue/pie-chart";

import CenterTemplateTwo from "@/modules/WorkLists/CenterTemplate2.vue";

const workListStore = useStoreWorkList();
const AreIdsShown = ref(true);

// & PROPS
const props = defineProps({
  widgetData: {
    type: Array,
    Default: () => {},
  },
  widget: {
    type: Object,
    Default: () => {},
  },
  widgetType: {
    type: Number,
    Default: () => {},
  },
});

// function pointClickHandlerLanguage({ target }) {
//   // console.log("pointClickHandler");
//   toastrError(" pointClickHandlerLanguage ");
//   // console.log("target");
//   // console.log(target);

//   // console.log("STUB in SELECTED obj DATA element  >>> Send to STORE >>");

//   // console.log("target.data");
//   // console.log(target.data.language);
//   // console.log(target.data.percent);

//   const seleWid = target.data.language;

//   // target.select()

//   if (target.isSelected()) {
//     target.clearSelection();
//     // console.log(" STORE SET Mut                             setSelectedSummaryWidget  ");
//     // ST set
//     this.$store.commit("reSetWIdgetFilter");
//   } else {
//     target.select();
//     // console.log(" STORE SET Mut                             setSelectedSummaryWidget  ");
//     // ST set
//     this.$store.commit("setWIdgetFilter", seleWid);
//   }
// }
// function customizePoint(pointInfo) {
//   // // console.log(' customizePoint pointInfo')

//   // // console.log(pointInfo)
//   // // console.log(pointInfo.value)
//   // // console.log('STATUS: ' + pointInfo.data.status + '            TOTAL: ' + pointInfo.data.total )

//   if (pointInfo.argument === "Non-Critical") {
//     return pointInfo.value ? { color: "#f9d88b" } : {};
//   } else if (pointInfo.argument === "Critical") {
//     return pointInfo.value
//       ? {
//           color: "#ff8e8e",

//           label: { font: { color: "red" } },
//         }
//       : {};
//   } else return pointInfo.value ? { color: "gray" } : {};
// }
// function onPointSelectionChanged({ target: point }) {
//   if (point.isSelected()) {
//     this.isOpen = true;

//     // Commands to execute when the point is selected
//     // console.log(" POINT  is SELECTED ");
//     // // console.log(point.data.lastName + '  :   ' + point.data.firstName + ' TaskCount: ' + point.data.taskCount)

//     // // console.dir(point.data.id)
//     // // console.log('----------------------')

//     // console.log(" STORE SET Mut                             setSelectedSummaryWidgetDetail  ");
//     // ST set
//     this.$store.commit("setSelectedSummaryWidgetDetail", point.data);
//     this.$store.commit("setPatientId", point.data.personId);
//     this.$store.dispatch("getPatientById", point.data.personId);
//     this.$store.dispatch("getPatientDXCodes", point.data.personId);

//     // this.$store.commit('getPatientById', point.data.id)

//     // var tTemp=        this.recordsSelectedDashHandler(point.data.id)
//     //   // console.log(tTemp)
//   } else {
//     this.isOpen = false;
//     // Commands to execute when the selection is cleared
//   }
// }

onMounted(() => {
  // console.log("onMounted() :      								WidgetThumbChart >>>>");
  // console.log("props : ");
  // console.log(props);
  // console.log(props.widgetData);
  // console.log('.widgetThumbNailTotal" ');
  // console.log(props.widgetData.widgetThumbNailTotal);
  // console.log(props.widget);
  // console.log(props.widgetType);
});
</script>

<style scoped></style>
